const ISTEMELI_WISHLIST_KEY = 'istemeli:wishlist';

function readWishlist() {
  try {
    const value = JSON.parse(localStorage.getItem(ISTEMELI_WISHLIST_KEY) || '[]');
    return Array.isArray(value) ? value.map(String) : [];
  } catch (_error) {
    return [];
  }
}

function writeWishlist(productIds) {
  try {
    localStorage.setItem(ISTEMELI_WISHLIST_KEY, JSON.stringify(productIds));
  } catch (_error) {
    // The card remains usable when storage is unavailable.
  }
}

function syncWishlistButtons() {
  const wishlist = readWishlist();

  document.querySelectorAll('[data-istemeli-wishlist-product]').forEach((button) => {
    const isSelected = wishlist.includes(String(button.dataset.istemeliWishlistProduct));
    button.setAttribute('aria-pressed', String(isSelected));
    button.title = isSelected ? 'Favorilerden çıkar' : 'Favorilere ekle';
  });
}

function startWishlistObserver() {
  if (!document.body) return;

  const observer = new MutationObserver((mutations) => {
    const hasNewProductCard = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some(
        (node) =>
          node.nodeType === Node.ELEMENT_NODE &&
          (node.matches?.('[data-istemeli-wishlist-product]') ||
            node.querySelector?.('[data-istemeli-wishlist-product]'))
      )
    );

    if (hasNewProductCard) syncWishlistButtons();
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-istemeli-wishlist-product]');
  if (!button) return;

  event.preventDefault();
  event.stopPropagation();

  const productId = String(button.dataset.istemeliWishlistProduct);
  const wishlist = readWishlist();
  const nextWishlist = wishlist.includes(productId)
    ? wishlist.filter((savedId) => savedId !== productId)
    : [...wishlist, productId];

  writeWishlist(nextWishlist);
  syncWishlistButtons();
});

document.addEventListener('DOMContentLoaded', () => {
  syncWishlistButtons();
  startWishlistObserver();
});
document.addEventListener('shopify:section:load', syncWishlistButtons);
